'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transmute = require('transmute');

var _notifications = require('conversations-core/notifications/notifications');

var _Visitor = require('conversations-core/data/records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _NotificationTypes = require('conversations-schema/constants/NotificationTypes');

var _NotificationTypes2 = _interopRequireDefault(_NotificationTypes);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _ChatActions = require('conversations-core/actions/ChatActions');

var _settingsSelectors = require('conversations-core/selectors/settingsSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (isAdmin) {
  return function (store) {
    function switchToChannel(channel) {
      store.dispatch((0, _ChatActions.setCurrentChannel)(channel));
    }

    function playNotifications(channel, message) {
      if (!isAdmin) {
        (0, _notifications.notifyBySound)(isAdmin);
        return;
      }

      var _store$getState = store.getState(),
          entities = _store$getState.entities;

      var userSettings = (0, _settingsSelectors.getUserSettings)(store.getState());

      // don't notify if the window has focus
      if (document.hasFocus()) {
        return;
      }

      if (userSettings[_NotificationTypes2.default.SOUND]) {
        (0, _notifications.notifyBySound)(isAdmin);
      }
      if (userSettings[_NotificationTypes2.default.TAB]) {
        (0, _notifications.notifyByTab)();
      }
      if (userSettings[_NotificationTypes2.default.PUSH]) {
        var vid = (0, _transmute.getIn)(['conversations', channel, 'vid'], entities);
        var visitor = (0, _transmute.getIn)(['visitors', vid], entities) || (0, _Visitor2.default)();

        (0, _notifications.notifyByPush)(channel, visitor, message, function () {
          return switchToChannel.apply(undefined, arguments);
        });
      }
    }

    function isRecipientMessage(message) {
      var from = (0, _ConversationalMessageModel.getFrom)(message);
      return isAdmin ? from === _RoleTypes2.default.VISITOR : from === _RoleTypes2.default.REP;
    }

    return function (next) {
      return function (action) {
        if (action.type === _ActionTypes2.default.RECEIVED_INCOMING_MESSAGE) {
          var _action$payload = action.payload,
              message = _action$payload.message,
              channel = _action$payload.channel;


          if (isRecipientMessage(message) && (0, _ConversationalMessageModel.isChatMessage)(message)) {
            playNotifications(channel, message);
          }
        }

        return next(action);
      };
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/NotificationMiddleware.js
// module id = 483
// module chunks = 0